// Identity key of a relation in the native PostgreSQL schema cache.
//
// Every key is built from CATALOG spellings (`pg_class` / `pg_namespace`
// names, `information_schema.columns`), which are exact: PostgreSQL holds
// `orders` and `"Orders"` as two relations, and so does this key. Each part
// is escaped (`\` and `|` get a `\`), so `"a|b".c` and `a."b|c"` never share a
// key either. It is an identity, never display text or SQL — a name typed in
// a query folds first (bare → lower case) and is looked up by the resolvers,
// not here.

export function pgTableKey(schema: string, name: string): string {
  return `${escapePart(schema)}|${escapePart(name)}`;
}

/** The `[schema, name]` a {@link pgTableKey} was built from. */
export function pgTableKeyParts(key: string): readonly [string, string] {
  const parts: string[] = [''];
  for (let i = 0; i < key.length; i++) {
    const ch = key[i]!;
    if (ch === '\\' && i + 1 < key.length) {
      parts[parts.length - 1] += key[++i];
    } else if (ch === '|') {
      parts.push('');
    } else {
      parts[parts.length - 1] += ch;
    }
  }
  return [parts[0] ?? '', parts.slice(1).join('|')];
}

function escapePart(part: string): string {
  return part.replace(/[\\|]/g, (c) => `\\${c}`);
}
